import moment from "moment";
import React from "react";
import {
  getCityAndClassId,
  getClassTypeCities,
  getClassTypes,
  getDailyAllowanceList,
  getDAValue,
} from "../../actions/UserAction";
import { onChange, setOptions, validateForm } from "./../../utils";
class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const detail = props.detail;
    this.state = {
      id: detail ? detail.id : "",
      minDate: "",
      maxDate: "",
      station: {
        name: "station",
        value: "",
        error: "",
        options: [],
        isRequired: true,
      },
      stationClass: {
        name: "stationClass",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      // dailyAllowance: { name: 'dailyAllowance', value: '' ,options:[], error: '', isRequired: true },
      noOfDas: {
        name: "noOfDas",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      noOfDaRs: { name: "noOfDaRs", value: "", error: "", isRequired: true },
      daysCount: { name: "daysCount", value: "", error: "", isRequired: true },
      amountRs: { name: "amountRs", value: "", error: "", isRequired: true },
    };
  }

  render() {
    const {
      station,
      amountRs,
      noOfDaRs,
      noOfDas,
      stationClass,
      dailyAllowance,
      daysCount,
    } = this.state;
    const { showLoader } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={this.onSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Class <small>*</small>
                    </label>

                    <select
                      className={
                        stationClass.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name={stationClass.name}
                      value={stationClass.value}
                      onChange={this.onChange}
                    >
                      <option value="">Select Class</option>

                      {stationClass && stationClass.options.length > 0 ? (
                        stationClass.options.map((ele: any, index: any) => {
                          return (
                            <>
                              <option value={ele.class} key={index}>
                                {ele.class}
                              </option>
                            </>
                          );
                        })
                      ) : (
                        <input
                          className={
                            stationClass.error.length > 0
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name={stationClass.name}
                          value={stationClass.value}
                          onChange={this.onChange}
                        />
                      )}

                      {/* <option value="">Select Class</option> */}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Station <small>*</small>
                    </label>

                    {stationClass.value != "B-2/C" ? (
                      <select
                        className={
                          station.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={station.name}
                        value={station.value}
                        onChange={this.onChange}
                      >
                        {/* <option value="">Select Class</option> */}
                        {station && station.options.length > 0
                          ? station.options.map((ele: any, index: any) => {
                              return (
                                <>
                                  <option value={ele.cities} key={index}>
                                    {ele.cities}
                                  </option>
                                </>
                              );
                            })
                          : ""}
                      </select>
                    ) : (
                      <input
                        className={
                          station.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={station.name}
                        value={station.value}
                        onChange={this.onChange}
                        placeholder="Others Cities"
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Type Of D.A.<small>*</small>
                    </label>

                    {station.value != "" ? (
                      <select
                        className={
                          noOfDas.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={noOfDas.name}
                        value={noOfDas.value}
                        onChange={this.onChange}
                      >
                        <option value="">Select D.A. Type </option>
                        {noOfDas && noOfDas.options.length > 0
                          ? noOfDas.options.map((ele: any, index: any) => {
                              return (
                                <>
                                  <option value={ele.DANames} key={index}>
                                    {ele.DANames}
                                  </option>
                                </>
                              );
                            })
                          : ""}

                        {/* <option value="">Select Class</option> */}
                      </select>
                    ) : (
                      <input
                        className={
                          noOfDas.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        name={noOfDas.name}
                        value={noOfDas.value}
                        onChange={this.onChange}
                        placeholder="********"
                        disabled
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Number Of D.A. Rs<small>*</small>
                    </label>
                    <input
                      type="number"
                      className={
                        noOfDaRs.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder={noOfDaRs.value}
                      name={noOfDaRs.name}
                      value={noOfDaRs.value}
                      // onChange={this.onChange}
                      // min={moment().subtract(2, 'month').format('YYYY-MM-DD')}
                      // max={moment().add(3, 'month').format('YYYY-MM-DD')}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Days Count <small>*</small>
                    </label>

                    <input
                      type="number"
                      className={
                        daysCount.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={daysCount.name}
                      value={daysCount.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Total <small>*</small>
                    </label>

                    <input
                      type="number"
                      className={
                        amountRs.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={amountRs.name}
                      value={amountRs.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>

                {/* <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                  */}
                <div className="col-md-6">&nbsp;</div>
                <div className="col-md-3">
                  <button
                    type="submit"
                    className="btn btn-block submit-button btn-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
  componentDidMount() {
    // const sd = moment().subtract(2, 'month').format('YYYY-MM-DD');
    // const ed = moment().add(3, 'month').format('YYYY-MM-DD');
    // this.setState({
    //     minDate: sd,
    //     maxDate: ed
    // });

    const {
      station,
      amountRs,
      noOfDaRs,
      noOfDas,
      stationClass,
      dailyAllowance,
    } = this.state;

    getClassTypes().then((res: any) => {
      setOptions(this, this.state.stationClass.name, res.result);
    });

    getDailyAllowanceList().then((res: any) => {
      setOptions(this, this.state.noOfDas.name, res.result);
    });
  }

  componentDidUpdate(prevProps: any, prevState: any, snapshot: any) {
    const { stationClass, station, noOfDas } = this.state;
    if (prevState.stationClass.value != stationClass.value) {
      getClassTypeCities(stationClass.value).then((res: any) => {
        setOptions(this, this.state.station.name, res.result);
      });
    }

    if (
      prevState.noOfDas.value != noOfDas.value ||
      prevState.stationClass.value != stationClass.value ||
      prevState.station.value != station.value
    ) {
      if ((stationClass.value && station.value && noOfDas.value) != "") {
        if (stationClass.value == "A/A-1") {
          getCityAndClassId(
            stationClass.value,
            station.value,
            noOfDas.value
          ).then((res: any) => {
            const model = {
              designationNameId: res.result.designationNameWithLevelId[0].id,
              groupId: res.result.groupAndCityNameId[0].code,
              DATypeId: res.result.dailyAllowanceId[0].id,
            };
            getDAValue(model).then((response: any) => {
              onChange(
                this,
                this.state.noOfDaRs.name,
                response.result[0].Amount
              );
            });
          });
        } else if (stationClass.value == "B-1") {
          getCityAndClassId(
            stationClass.value,
            station.value,
            noOfDas.value
          ).then((res: any) => {
            const model = {
              designationNameId: res.result.designationNameWithLevelId[0].id,
              groupId: res.result.groupAndCityNameId[0].code,
              DATypeId: res.result.dailyAllowanceId[0].id,
            };
            getDAValue(model).then((response: any) => {
              onChange(
                this,
                this.state.noOfDaRs.name,
                response.result[0].Amount
              );
            });
          });
        } else if (stationClass.value == "B-2/C") {
          getCityAndClassId(
            stationClass.value,
            station.value,
            noOfDas.value
          ).then((res: any) => {
            const model = {
              designationNameId: res.result.designationNameWithLevelId[0].id,
              groupId: res.result.groupAndCityNameId[0].code,
              DATypeId: res.result.dailyAllowanceId[0].id,
            };
            getDAValue(model).then((response: any) => {
              onChange(
                this,
                this.state.noOfDaRs.name,
                response.result[0].Amount
              );
            });
          });
        } else {
          console.log("nothing ");
        }
      }
    }
  }

  onChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    const { amountRs } = this.state;

    if (name == this.state.daysCount.name) {
      let total = parseInt(value) * parseInt(this.state.noOfDaRs.value);
      onChange(this, amountRs.name, total);
      onChange(this, name, value);
    } else {
      onChange(this, e.target.name, e.target.value, () => {
        // const { da, fare, total } = this.state;
        // const sum = parseFloat(fare.value) + parseFloat(da.value)
        // const nanCheck = isNaN(sum);
        // !nanCheck && onChange(this, total.name, sum);
      });
    }
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    // if (validateForm(this) && this.compareDates()) {
    if (validateForm(this)) {
      const st = this.state;
      this.setState({ showLoader: true });
      const model = {
        // id: st.id,
        stationClass: st.stationClass.value,
        station: st.station.value,
        noOfDas: st.noOfDas.value,
        noOfDaRs: st.noOfDaRs.value,
        days: st.daysCount.value,
        amountRs: st.amountRs.value,
        // fare: parseFloat(st.fare.value),
        // da: parseFloat(st.da.value),
      };
      // if (st.id === "") {
      //     model.id = new Date().getTime();
      // }

      this.props.onSubmit(model);
    }
  };

  compareDates = () => {
    const st = this.state;
    const startDate = moment(st.startDate.value);
    const endDate = moment(st.endDate.value);
    const diff = endDate.diff(startDate);

    if (diff >= 0) {
      return true;
    } else {
      alert("Start date must be less than end date");
      return false;
    }
  };
}

export default ComponentName;
